<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="packagetable === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-tabela-preco')"
      ></el-page-header>
      <el-page-header
        v-if="packagetable !== ''"
        @back="back"
        title
        :content="$t('atualizar-tabela-preco')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        size="mini"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('pacote')" prop="package">
              <PackageTableList
                v-model="ruleForm.packagetable"
                v-bind:current="ruleForm.packagetable"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('grupo-servico')" prop="service">
              <ServicesGroupList
                v-model="ruleForm.servicesgroup"
                v-bind:current="ruleForm.servicesgroup"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-button @click="add()">Novo peso</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="4" v-for="(record, index) of items" v-bind:key="index">
          <el-col :xs="15" :sm="10" :md="10" :lg="2" :xl="2">
            <el-form-item :label="$t('peso-inicial')" prop="weightstart">
              <el-input-number
                ref="weightstart"
                controls-position="right"
                style="width: 100%"
                v-model="record.weightstart"
              ></el-input-number>
              <el-link @click="remove(index)" type="danger"
                >Remover item</el-link
              >
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="2" :xl="2">
            <el-form-item :label="$t('peso-final')" prop="weightend">
              <el-input-number
                ref="weightend"
                style="width: 100%"
                controls-position="right"
                v-model="record.weightend"
              ></el-input-number>
              <el-checkbox v-model="record.aditional"
                >Peso adicional</el-checkbox
              >
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="L1" prop="l1">
              <el-input ref="name" v-model="record.l1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="L2" prop="l2">
              <el-input ref="name" v-model="record.l2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="L3" prop="l3">
              <el-input ref="name" v-model="record.l3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="L4" prop="l4">
              <el-input ref="name" v-model="record.l4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="E1" prop="e1">
              <el-input ref="name" v-model="record.e1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="E2" prop="e2">
              <el-input ref="name" v-model="record.e2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="E3" prop="e3">
              <el-input ref="name" v-model="record.e3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="E4" prop="e4">
              <el-input ref="name" v-model="record.e4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="N1" prop="n1">
              <el-input ref="name" v-model="record.n1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="N2" prop="n2">
              <el-input ref="name" v-model="record.n2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="N3" prop="n3">
              <el-input ref="name" v-model="record.n3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="N4" prop="n4">
              <el-input ref="name" v-model="record.n4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="I1" prop="i1">
              <el-input ref="name" v-model="record.i1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="I2" prop="i2">
              <el-input ref="name" v-model="record.i2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="I3" prop="i3">
              <el-input ref="name" v-model="record.i3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="I4" prop="i4">
              <el-input ref="name" v-model="record.i4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="P1" prop="p1">
              <el-input v-model="record.p1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="P2" prop="p2">
              <el-input ref="p2" v-model="record.p2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="P3" prop="p3">
              <el-input ref="p3" v-model="record.p3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="1" :xl="1">
            <el-form-item label="P4" prop="p4">
              <el-input ref="p4" v-model="record.p4"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="packagetable === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="packagetable !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { PriceTableService } from "@/services/customers/price.table.services";
import { i18n } from "@/plugin/i18n";
import ServicesGroupList from "@/xpost/views/register/services.group/ServicesGroupList";
import PackageTableList from "@/xpost/views/financial/package/PackageTableList";

export default {
  name: "PriceTableAdd",
  components: {
    ServicesGroupList,
    PackageTableList,
  },
  data() {
    return {
      packagetable: "",
      servicegroup: "",
      tableDetail: [],
      items: [],
      ruleForm: {
        packagetable: "",
        servicesgroup: "",
      },
      rules: {
        packagetable: [
          {
            required: true,
            message: "Tabela de Pacote deve ser obrigatório",
            trigger: "blur",
          },
        ],
        servicesgroup: [
          {
            required: true,
            message: "Grupo do serviço deve ser obrigatório",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "price.table",
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      PriceTableService.findByPackageService(vm.packagetable, vm.servicegroup)
        .then((response) => {
          vm.ruleForm.packagetable = vm.packagetable;
          vm.ruleForm.servicesgroup = vm.servicegroup;
          vm.items = response;

          /*vm.ruleForm.weightstart = response.weightstart;
          vm.ruleForm.weightend = response.weightend;
          vm.ruleForm.e1 = response.e1;
          vm.ruleForm.e2 = response.e2;
          vm.ruleForm.e3 = response.e3;
          vm.ruleForm.e4 = response.e4;
          vm.ruleForm.l1 = response.l1;
          vm.ruleForm.l2 = response.l2;
          vm.ruleForm.l3 = response.l3;
          vm.ruleForm.l4 = response.l4;
          vm.ruleForm.n1 = response.n1;
          vm.ruleForm.n2 = response.n2;
          vm.ruleForm.n3 = response.n3;
          vm.ruleForm.n4 = response.n4;
          vm.ruleForm.n5 = response.n5;
          vm.ruleForm.n6 = response.n6;
          vm.ruleForm.i1 = response.i1;
          vm.ruleForm.i2 = response.i2;
          vm.ruleForm.i3 = response.i3;
          vm.ruleForm.i4 = response.i4;
          vm.ruleForm.i5 = response.i5;
          vm.ruleForm.i6 = response.i6;*/
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          PriceTableService.add(vm.ruleForm, vm.items)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("tabela-preco-adicionada-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          PriceTableService.update(
            vm.packagetable,
            vm.servicegroup,
            vm.ruleForm,
            vm.items
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("tabela-preco-atualizado-sucesso"),
              });
              vm.$router.replace({
                name: "price.table",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    remove(index) {
      const vm = this;
      vm.items.splice(index, 1);
    },
    add() {
      const vm = this;
      vm.items.push({
        id: null,
        sequence: vm.items.length,
        weightstart: 0,
        weightend: 0,
        aditional: false,
        l1: 0,
        l2: 0,
        l3: 0,
        l4: 0,
        e1: 0,
        e2: 0,
        e3: 0,
        e4: 0,
        n1: 0,
        n2: 0,
        n3: 0,
        n4: 0,
        i1: 0,
        i2: 0,
        i3: 0,
        i4: 0,
        p1: 0,
        p2: 0,
        p3: 0,
        p4: 0,
      });
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.packagetable && this.$route.params.servicegroup) {
      vm.packagetable = this.$route.params.packagetable;
      vm.servicegroup = this.$route.params.servicegroup;
      vm.get();
    } else {
      vm.add();
      vm.$refs.companyname.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
